import React from "react";
import g from "glamorous";
import { css } from "glamor";
import Link from "gatsby-link";
import Button from '@material-ui/core/Button';

import { rhythm } from "../utils/typography";

export default ({ children, data }) =>
<g.Div>
  <g.Div
    margin={`0 auto`}
    maxWidth={800}
    padding={rhythm(1)}
    border-left={`thin solid grey`}
  >
    <Link to={`/`}>
      <g.H3 marginBottom={rhythm(0)} display={`inline-block`}>
        {data.site.siteMetadata.title}
      </g.H3>
    </Link>
      {/* <g.A
        float={`right`}
        padding={`0rem`}
        href={`https://resume.jethrolai.com`} target="_blank">
        Resume
      </g.A> */}
      <g.H4
        float={`right`}
        padding={`0rem`}
        display={`inline-block`}
      >
        <g.A
          href={`https://resume.jethrolai.com`} target="_blank" style={{ textDecoration: 'none', color: 'inherit'}}>
          <Button variant="contained" color="primary">
            Resume
          </Button>
        </g.A>
      </g.H4>
  </g.Div>
  <g.Hr
    margin={`0 auto`}
    padding={rhythm(0)}
  />
  <g.Div
    margin={`0 auto`}
    maxWidth={800}
    padding={rhythm(1)}
    border-left={`thin solid grey`}
  >
    {/* <Link marginLeft={rhythm(2)} className={linkStyle} to={`/who/`}>
      Who
      </Link>
      <Link marginLeft={rhythm(2)} className={linkStyle} to={`/What/`}>
      What
      </Link>
      <Link marginLeft={rhythm(2)} className={linkStyle} to={`/why/`}>
      Why
    </Link> */}

    {children()}
  </g.Div>
  <g.Div
      margin={`0 auto`}
      maxWidth={800}
      padding={rhythm(1)}
      border-left={`thin solid grey`}>
    {/* footer */}
  </g.Div>
</g.Div>

export const query = graphql`
query LayoutQuery {
  site {
    siteMetadata {
      title
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js